import { render } from "./ThePointsbar.vue?vue&type=template&id=8d3fea50&scoped=true"
import script from "./ThePointsbar.vue?vue&type=script&lang=js"
export * from "./ThePointsbar.vue?vue&type=script&lang=js"

import "./ThePointsbar.vue?vue&type=style&index=0&id=8d3fea50&scoped=true&lang=scss"

import exportComponent from "D:\\work\\feedback_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3fea50"]])

export default __exports__